import MenuLink from './MenuLink';

export default MenuLink;
